import React, { Component } from "react";
import AsyncComponent from "../../../components/async-component";
import PageWrap from "../../../components/page-wrap";
import PageContent from "../../../components/page-content";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import { PictogramContextProvider } from "./context/pictogram-content";

class BSPictogram extends Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <PictogramContextProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </PictogramContextProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default BSPictogram;
